module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/translate-cc98e10a0f8e1854f3df2b820c5966af.svg";